import React, { useState, useEffect } from 'react';
import { getUserInfo } from '../apiUser';
import { updateUser } from './apiDashboard';
import { isAuthenticated } from '../../auth';
import DashboardShell from './DashboardShell';
import EmailValidator from 'email-validator';

const ProfileDashboard = () => {
    const [userInfo, setUserInfo] = useState({
        name: '',
        email: '',
        profile_picture: '',
    });

    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const { name, email, profile_picture, formData } = userInfo;

    const { user: {_id}, token } = isAuthenticated();

    useEffect(() => {
        getUserInfo(_id).then(data => {
            setUserInfo({name: data.name, email: data.email, profile_picture: data.profile_picture});
        });
    },[]);

    const handleChange = name => event => {
        if (name === 'profile_picture') {
            const previewURL = URL.createObjectURL(event.target.files[0])
            setUserInfo({...userInfo, profile_picture: previewURL})
            //formData.set('profile_picture', event.target.files[0]);
        }
        else {
            const value = name === 'profile_picture' ? event.target.files[0] : event.target.value;
            //formData.set(name, value);
            setUserInfo({...userInfo, [name]: value})
        }
    };

    const handleValidation = () =>{
        if (!name) {
            setError('Username cannot be left empty');
            return false;
        }
        else {
            if (!name.match('^[a-zA-Z0-9 ]{4,15}$')) { //no special characters
                setError('Username cannot contain special characters and must be 4-15 characters long');
                return false;
            }
        }
        if (email === '') {
            setError('Email cannot be left empty');
            return false;
        }
        else {
            if (!EmailValidator.validate(email)) {
                setError('Email must be valid');
                return false;
            }
        }

        /*
        if (!profile_picture) {
            setValues({...values, error: 'Please select a profile picture (or choose a random one)', success: false});
            return false;
        }
        */


        return true;
    }; 

    const clickSubmit = e => {
        if (!handleValidation()) { return; }

        e.preventDefault();
        updateUser(_id, userInfo, token).then(data => {
            if (data.error) {
                if (data.error.codeName === 'DuplicateKey') {
                    if (data.error.keyPattern.name === 1) {
                        setError('A user with that name already exists');
                    }
                    else {
                        setError('A user with that email already exists');
                    }
                }
                else {
                    setError('There was an error updating your user information');
                }
                return
            }
            console.log('asdfasdfas');
            setSuccess(true);
        });
    };

    const Error = () => (
        <p className='text-red-400 p-2'> {error} </p>
    );

    const Success = () => (
        <p className='text-green-400 p-2'>Profile successfully updated</p>
    );

    return (
        <DashboardShell title={'Profile Information'}>
            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                <form>
                    {error && <Error/> }
                    {success && <Success/>}
                    <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                        <dl className="sm:divide-y sm:divide-gray-200">
                            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium text-gray-500">Username</dt>

                                <input
                                    id="username"
                                    onChange={handleChange('name')}
                                    value={name}
                                    name="username"
                                    type="text"
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none   focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />

                            </div>
                            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium text-gray-500">Email</dt>
                                <input
                                    id="email"
                                    onChange={handleChange('email')}
                                    value={email}
                                    name="email"
                                    type="text"
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none   focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />

                            </div>
                            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium text-gray-500">Profile Picture</dt>

                                    <img alt='profile_photo'className='rounded-full h-10 w-10 mb-3' src={profile_picture}/>
                                <label
                                    htmlFor='pfp_upload'
                                >
                                    <span
                                        htmlFor='pfp_upload'
                                        className= 'bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-7  00 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                                        Choose File
                                    </span>

                                    <input
                                        id='pfp_upload'
                                        name='pfp_upload'
                                        type='file'
                                        accept='/image/*'
                                        onChange={handleChange('profile_picture')}
                                        className='sr-only'
                                    />
                                </label>
                            </div>
                        </dl>


                    </div>
                </form>


            </div>
                        <button
                            type="button"
                            onClick={clickSubmit}
                            className="inline-flex items-center px-5 py-2 border border-transparent text-xs font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focusring-offset-2 focus:ring-indigo-500 mt-3"
                        >
                            Save
                        </button>
        </DashboardShell>
    );
};

export default ProfileDashboard;
